import { create } from 'zustand'
import Cookies from 'js-cookie'

export const useSearchDemandStore = create((set) => ({
    searchData: {
        "Row": "",
        "Mobile": "",
        "FullName": "",
        // "SearchType": "Sale",
        "dealType": "buy",
        "limit": 10,
        "AgencyId": [Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id],
        "LocationId": Cookies.get('locationId') && Cookies.get('locationId'),
        'PropertyTypes': "",
        'Aggregation': "",
        'EstateStatus': "",
        'Dongs': "",
        'CertificateTypes': "",
        'Facilities': "",
        'Tags': "",
        'UsageTypes': "",
        'Areas': [],
        'RentPrefers': "",
        'PropertyAge': "",
        'MinRoomsCount': "",
        'MinSpace': "",
        'MaxSpace': "",
        'MinSalePrice': "",
        'MaxSalePrice': "",
        'MinMortgagePrice': "",
        'MaxMortgagePrice': "",
        'MinRentPrice': "",
        'MaxRentPrice': "",
        'MinPresalePrice': "",
        'MaxPresalePrice': "",
        "StoreyNo": [],
        "IsArchived": "",
        "Elevator": "",
        "Parking": "",
        "Store": "",
        "MaxStoreyCount": "",
        "MaxPropertyAgeYear": "",
        "MaxInfrastructure": "",
        "MinInfrastructure": "",
        "MinRegisterDate": "",
        "MinPropertyAgeYear": ""

    },
    setSearchData: (newData) => set((state) => {
        return { ...state, searchData: { ...state.searchData, [newData.name]: newData.value } }
    },
    ),
    emptySearchData: () => set((state) => {
        const tmp = { ...state.searchData }
        for (const i in tmp) {
            if (i == "Limit")
                tmp[i] = 10
            else if (i == "LocationId")
                tmp[i] = Cookies.get('locationId') ? Cookies.get('locationId') : ''
            else if (i == "AgencyId")
                tmp[i] = Cookies.get('agency') ? JSON.parse(Cookies.get('agency')).Id : ''
            else if (i == "StoreyNo")
                tmp[i] = []
            else if (i == "dealType")
                tmp[i] = "buy"
            else if (i == "Areas")
                tmp[i] = []
            else
                tmp[i] = ""
        }
        return { ...state, searchData: tmp }
    },
    ),
}))